import { FETCH_SITE } from "../actions/siteActions";

const initState = {};

const siteReducer = (state = initState, action) => {
    if (action.type === FETCH_SITE) {
        return {
            ...state,
            ...action.payload,
        };
    }

    return state;
};

export default siteReducer;
